import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register', '/homePage','/forgetPwd', '/RecruitmentOrder','/RecruitmentDetails','/AboutUs','/article']
const Token = localStorage.getItem('token')
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (Token) {
      next() 
      NProgress.done()
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
      NProgress.done()
    } else {
      next(`/login`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})